// SCROLL TO TOP
tetloose.scrolr = function () {
    var $scrollAmount = $window.scrollTop(),
        $scrolr = $('[rel=js-scrolr]'),
        $scrolrOffset = 300,
        $scrolrDuration = 700;

    $scrolr.on('click', function(e) {
        e.preventDefault();
        $('body,html').animate( {
            scrollTop: 0,
        }, $scrolrDuration );
    });

    $window.on('scroll', function() {
        $scrollAmount = $window.scrollTop();
        if ($scrollAmount > $scrolrOffset) {
            $scrolr.addClass('is-visible');
            return false;
        }
        $scrolr.removeClass('is-visible');
    });
};
